import PromptHeader from "./PromptHeader";

export default PromptHeader;